import React from 'react';
import PropTypes from 'prop-types';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import CustomStep from 'workOrderComponents/close/CustomStep';

class InsideHomeAccess extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.handleRadioGroupChange = this
            .handleRadioGroupChange
            .bind(this);

    }


    handleRadioGroupChange(e, value) {
        const {workOrderActions, orderId} = this.props;

        if (value) {
            workOrderActions.markOrderInHomeAccessNeededAs(value, orderId);
        }
        else {
          workOrderActions.markOrderInHomeAccessNeededAs(value, orderId);
        }

    }

    render() {
        const {workOrderActions, orderCloseDetails, stepConfig, orderId, disabled} = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');
        const insideHomeAccessVal = orderCloseDetails.getIn(['closeOrderRequest', 'inHomeAccessNeededToComplete']);

        return (
            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={'Inside Access Needed to Complete Job?'}
                stepConfig={stepConfig}
                stepConfigKey="insideHomeAccessStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="insideHomeAccess">

                <div className="margin-top-and-bottom threefourths-em">

                    <RadioButtonGroup
                        style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                        onChange={this.handleRadioGroupChange}
                        name="insideHomeAccess"
                        valueSelected={insideHomeAccessVal}>
                        <RadioButton
                            disabled={disabled}
                            value={false}
                            label="No"
                            style={{
                            display: 'inline-block'
                        }}/>
                        <RadioButton
                            disabled={disabled}
                            value={true}
                            label="Yes"
                            style={{
                            display: 'inline-block'
                        }}/>
                    </RadioButtonGroup>

                </div>
            </CustomStep>
        );

    }
}

InsideHomeAccess.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    stepConfig: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool
};

export default InsideHomeAccess;



// WEBPACK FOOTER //
// ./src/components/ticket/InsideHomeAccess.js